export function initForAlpine(alpine) {
  if (navigator.clipboard) {
    alpine.directive("clipboard-copy", directive);
  }
}

function directive(element, { expression }, { cleanup }) {
  const handler = createHandler(expression);

  element.addEventListener("click", handler);

  cleanup(() => {
    element.removeEventListener("click", handler);
  });
}

function createHandler(text) {
  return function (event) {
    event.preventDefault();
    navigator.clipboard.writeText(text);
  };
}
